<template>

    <div v-cloak class="container-fluid">

        <div class="row">
            <div class="col">
                <h4 class="text-portal-soft-black pt-2" v-once>{{cmsContentBlocks['templateSelector.MainPage.Header']}}</h4>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <hr class="mt-0 mb-0 border-none taller-hr">
            </div>
        </div>

        <div class="row mt-3">
            <div class="col">
                <h5 class="text-portal-soft-black" v-once>{{cmsContentBlocks['patientRep.Header']}}</h5>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <span class="text-portal-soft-red" v-once>{{cmsContentBlocks['allFieldsAreRequiredHeaderImportant']}}</span>
                <span class="text-portal-soft-black" v-once>{{cmsContentBlocks['allFieldsAreRequiredHeader']}}</span>
            </div>
        </div>

        <div class="row mt-2 mt-lg-0">
            <div class="col">

                <div class="row">
                    <div class="col">
                        <hr>
                    </div>
                </div>

                <div class="row text-portal-soft-black mb-2">
                    <div class="col" v-once v-html="cmsContentBlocks['patientRep.Description']">
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <hr>
                    </div>
                </div>

                <div class="row text-portal-soft-black mb-2">
                    <div class="col" v-once>
                        {{cmsContentBlocks['patientRep.ToMessage']}}
                    </div>
                </div>

                <div class="row text-portal-soft-black mb-2">
                    <div class="col" v-once>
                        {{cmsContentBlocks['patientRep.Subject']}}
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <hr>
                    </div>
                </div>

                <div>
                    <div class="row text-portal-soft-black mb-2">
                        <div class="col">
                            {{cmsContentBlocks['patientRep.ProviderLabel']}}
                        </div>
                    </div>
                </div>

                <div>
                    <div class="row mb-2">
                        <div class="col">
                            <select2-component key="drDropDown" title="Send message to this person" v-error-message="{ errorModel: 'errorModel.providerId' }" class="form-control" :allowclear="false" :addblankentry="false" :options="physicianDropDown" v-model="messageModel.providerId" :placeholder="cmsContentBlocks['patientRep.ProviderPlaceholder']">
                            </select2-component>
                            <span class="invalid-feedback is-invalid">{{ errorModel.providerId | firstError }}</span>
                        </div>
                    </div>
                </div>

                <div class="row text-portal-soft-black mb-2">
                    <div class="col" v-once>
                        {{cmsContentBlocks['patientRep.PhoneNumber']}}
                    </div>
                </div>

                <div class="row text-portal-soft-black mb-2">
                    <div class="col">
                        <input type="text" aria-label="Phone Number" v-mask="usaPhoneNumberFormat" v-error-message="{ errorModel: 'errorModel.phoneNumber' }" class="form-control" maxlength="25" v-model="messageModel.phoneNumber" :placeholder="cmsContentBlocks['patientRep.PhoneNumberTextBoxPlaceHolder']" />
                        <span class="invalid-feedback is-invalid">{{ errorModel.phoneNumber | firstError }}</span>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <!--<banner-component v-if="nonEnglish" :bannerText="cmsContentBlocks.messageMustBeInEnglish"></banner-component>-->
                        <message-body-component v-model="messageModel.messageBody"
                                                :error-model="errorModel"
                                                :cms-content-blocks="cmsContentBlocks"
                                                :non-english="nonEnglish"
                                                :text-area-style-object="{ height: '200px !important' }"></message-body-component>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <upload-component :attachment-group-id="attachmentGroupId">
                            <template v-slot:multiple-error-slot>
                                <span class="invalid-feedback is-invalid d-inline">{{ errorModel.attachmentGroupId | firstError }}</span>
                            </template>
                        </upload-component>
                    </div>
                </div>

            </div>

        </div>

    </div>

</template>

<script>

    import formattingDirective from '@SharedVueComponents/formatting/formattingdirective';
    import errorMessageDirective from '@SharedVueComponents/Validation/ErrorMessageDirective';
    import composeMessageBody from '../../Common/message.body.vue';
    import uploadComponent from '@PortalVueComponents/Uploader/file.multiple.uploader.vue';
    import select2Component from '@SharedVueComponents/select2/select2.vue';
    import { mask } from 'vue-the-mask'
    import { usaPhoneNumberFormat } from '@SharedServices/formatting.service';
    import mskBanner from '@PortalVueComponents/Banner/msk.banner.vue'

    export default {
        name: 'patientRepTemplate',
        props: {
            physicianDropDown: { type: Array },
            errorModel: { type: Object },
            attachmentGroupId: { type: String },
            cmsContentBlocks: { type: Object },
            nonEnglish: { type: Boolean }
        },
        components: {
            'select2-component': select2Component,
            'message-body-component': composeMessageBody,
            'upload-component': uploadComponent,
            'banner-component': mskBanner
        },
        directives: {
            mask
        },
        data: function () {
            return {
                usaPhoneNumberFormat,
                messageModel: {
                    providerId: null,
                    phoneNumber: null,
                    attachmentGroupId: this.attachmentGroupId,
                    messageBody: '',
                },
            }
        },
        mounted: function () {

            //go send back the model right away
            this.$emit('setMessageObject', this.messageModel);
        },
        watch: {

            messageModel: {
                handler: function (newValue) {
                    this.$emit('setMessageObject', newValue);
                },
                deep: true
            }
        }
    };
</script>

